<template>
  <span
    class="d-inline-flex align-items-center hover-control position-relative"
  >
    <b-img
      v-if="item?.profileUrl"
      :src="item.profileUrl"
      class="group-users border border-white"
    />
    <div
      class="group-users d-inline-flex justify-content-center align-items-center text-10 text-white"
      :style="{
        backgroundColor: stringToColour(item.korNm + item.idKistUser),
      }"
      v-else
    >
      {{ item.korNm.substr(0, 1) }}
    </div>
    <span v-if="showName" class="ml-1 lh-100" :class="textClass">
      {{ `${item.korNm}` }}{{ showId ? `(${item.idKistUser})` : "" }}
      {{ showRole ? `(${item.authorityName})` : "" }}
    </span>
    <div
      class="hover-target position-absolute bg-white border border-secondary px-2 rounded-pill text-nowrap"
      :style="{ top: 'calc(100% + 2px)', left: 0, zIndex: 1 }"
    >
      {{ item.korNm }} ({{ item.idKistUser }})
    </div>
  </span>
</template>

<script>
import SHA256 from "crypto-js/sha256";
export default {
  props: {
    item: { type: Object, default: () => {}, require: true },
    showName: { type: Boolean, default: false },
    showId: { type: Boolean, default: false },
    showRole: { type: Boolean, default: false },
    textClass: { type: [String, Object, Array], default: "" },
  },

  methods: {
    stringToColour(str) {
      var hash = 0;
      str = SHA256(str + "KIRINOTE").toString();
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var color = "#";
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xff;
        color += ("00" + Math.floor(value * 0.7).toString(16)).substr(-2);
      }
      return color;
    },
  },
};
</script>

<style lang="scss" scoped></style>
